import { put, call } from "redux-saga/effects";
import * as actions from "../actions";
import * as Api from "../../api";

// eslint-disable-next-line import/prefer-default-export
export function* requestLatestJobsData({ payload }) {
  yield put(actions.latestJobsSetIsLoading(true));
  try {
    const response = yield call(
      Api.getLatestJobs,
      payload.latitude,
      payload.longitude
    );
    if (response.status === 200) {
      if (typeof response.data === "string") {
        yield put(actions.addError("latestJobs", response.data));
      }
      const latestJobs = response.data.data.value;
      yield put(actions.latestJobsSetData({ latestJobs }));
    }
  } catch (err) {
    yield put(actions.addError("latestJobs", err));
  } finally {
    yield put(actions.latestJobsSetIsLoading(false));
  }
}
